import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  Input,
  FormLabel,
  Divider,
  Checkbox,
  Tooltip,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
const Url = ({ field, handleOnChange }) => {
  const styleClasses = field.styleClasses.length
    ? field.styleClasses.join(" ")
    : "";
  return (
    <Box mt="16px" w="380px" h="333.93">
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Label
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.label}
          placeholder="Enter label"
          onChange={(e) => handleOnChange(e, "label")}
        />
        <Checkbox
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          mt="12px"
          isChecked={field.showLabel}
          onChange={(e) => handleOnChange(e, "showLabel")}
        >
          Show label
        </Checkbox>
      </FormControl>
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Add a new placeholder
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.placeholder}
          placeholder="Enter placeholder"
          onChange={(e) => handleOnChange(e, "placeholder")}
        />
      </FormControl>
      <FormControl mb="24px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Add a helptext
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.helpText}
          placeholder="Enter helptext"
          onChange={(e) => handleOnChange(e, "helpText")}
        />
      </FormControl>
      <Divider />
      <FormControl mt="24px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Form css class{" "}
          <Tooltip
            label="Enter multiple css classes separated by space"
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={styleClasses}
          placeholder="Enter css class name"
          onChange={(e) => handleOnChange(e, "styleClasses")}
        />
      </FormControl>
    </Box>
  );
};

Url.propTypes = {
  field: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

export default Url;
